export default {
  acknowledgment: {
    ageRestricted: 'Edad restringida',
    dontAskAgain: 'No me preguntes más',
    legalDrinkingAge: 'Al continuar, reconoces que eres mayor de edad para beber.',
    showIdPrompt: 'Por favor esté preparado para mostrar identificación bajo petición',
    doNotShowAgain: 'No me muestre este mensaje de nuevo'
  },
  actions: {
    add: 'Añadir',
    addNew: 'Añadir nuevo',
    addThing: 'Añadir {thing}',
    applied: 'Aplicado',
    apply: 'Aplicar',
    call: 'Llamar',
    cancel: 'Cancelar',
    change: 'Cambiar',
    changeTo: 'Cambiar a {subject}',
    close: 'Cerrar',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    deleteAll: 'Eliminar todo',
    details: 'Detalles',
    dismiss: 'Descartar',
    edit: 'Editar',
    favorited: 'Favorito',
    learnMoreAbout: 'Aprende más sobre {subject}',
    link: 'Vincular',
    loadMore: 'Cargar más',
    ok: 'OK',
    prorate: 'Prorratear',
    remove: 'Eliminar',
    replace: 'Reemplazar',
    retry: 'Reintentar',
    review: 'Revisar',
    save: 'Guardar',
    seeAll: 'Ver todo',
    selected: 'Seleccionado',
    summarizeBy: 'Resumir por',
    update: 'Actualizar',
    watched: 'Visto',
    reserve: 'Reservar',
    getDirections: 'Get Directions',
    bookNow: 'Book Now',
    addToCalendar: 'Añadir al calendario',
    googleCalendar: 'Calendario de Google',
    outlookCalendar: 'Calendario de Outlook',
    appleCalendar: 'Calendario de Apple'
  },
  activityBooking: {
    bookingId: 'ID de reserva {bookingId}',
    errors: {
      minimumAttendanceRequirementsNotMet: 'No se cumplen los requisitos de asistencia mínima',
      noDateAndTimeSelected: 'No se ha seleccionado fecha y/o hora'
    },
    guest: {
      name: 'Invitado'
    },
    form: {
      reservationDate: 'Fecha de reserva',
      reservationTime: 'Hora de reserva',
      space: 'Espacio',
      paymentStatus: 'Estado del pago',
      guests: 'Invitados',
      activity: 'Actividad',
      sessions: 'Sesiones',
      phone: 'Teléfono',
      waitTime: 'Tiempo de espera',
      notes: 'Notas',
      editBooking: 'Editar Reserva',
      cancelBooking: 'Cancelar Reserva',
      none: 'Ninguno',
      activityBookingSaved: 'Reserva de actividad guardada',
      waitlistFullName: 'Contacto de la lista de espera',
      waitlistEmailAddress: 'Correo electrónico',
      waitlistPhoneNumber: 'Número de teléfono',
      waitlistNotificationLastSentAt: 'Última notificación de lista de espera enviada a las',
      priceVariesByTime: 'de {price} varía por tiempo'
    }
  },
  assertion: {
    happyToReceiveMarketingFrom: 'Me complace recibir horarios, promociones y otra información útil de {siteName}',
    no: 'No',
    notNow: 'Ahora no',
    or: 'o',
    minimumAgeAgreement: 'Tengo al menos {age} años de edad.',
    tosAgreement: 'He leído y acepto los {termsOfService}',
    tosAndPrivacyPolicyAgreement: 'He leído y acepto los {termsOfService} y la {privacyPolicy}',
    yes: 'Sí'
  },
  auth: {
    actions: {
      goToForgotPassword: 'Olvidé mi contraseña',
      login: 'Iniciar sesión',
      loginToDo: 'Inicie sesión para {action}',
      logout: 'Cerrar sesión',
      register: 'Regístrate',
      registerOrLogin: 'Regístrate o inicia sesión',
      sendEmailToClaimAccount: 'Enviar correo electrónico para acceder a la cuenta',
      sendPasswordResetEmail: 'Enviar correo de restablecimiento',
      signup: 'Regístrate'
    },
    errors: {
      registrationMinimumAgeRequired: 'Debes tener al menos {age} años de edad para crear una cuenta'
    },
    hint: {
      userClass: 'Clase de titular de boleto'
    },
    logInConfirmation: 'Bienvenido {name}, ya has iniciado sesión',
    activateAccountHeading: 'Activar cuenta',
    alreadyHaveAnAccountQuestion: '¿Ya tiene una cuenta?',
    areYouAnExistingCustomerQuestion: '¿Eres un cliente existente?',
    claimingAccountExplanation: 'Para acceder a su cuenta, necesitamos asociar una dirección de correo electrónico con su cuenta',
    claimingAccountInstructions: ctx => {
      const siteEmail = ctx.named('siteEmail') || ''
      const sitePhone = ctx.named('sitePhone') || ''
      let message = 'Puede hacerlo viniendo al cine, enviándonos un correo electrónico'
      message += siteEmail ? ` a ${siteEmail}` : ''
      message += sitePhone ? ` o llamando al ${sitePhone}` : ' o llamándonos por teléfono'
      return message
    },
    claimingAnAccountHeading: 'Accediendo a la cuenta',
    claimYourAccountHeading: 'Acceda a su cuenta',
    dontHaveAnAccount: '¿No tienes una cuenta?',
    existingAccountPromptToClaim: 'Usted tiene una cuenta/membresía en el cine. Haga clic aquí para acceder a su cuenta',
    existingAccountPromptToClaimWithoutEmail: 'Usted tiene una cuenta/membresía en el cine pero no tiene una dirección de correo electrónico registrada',
    noAccountPromptToRegister: 'Usted no tiene una cuenta/membresía en el cine. ¡Haga clic aquí para registrarse!',
    resetPasswordHeading: 'Restablecer su contraseña',
    resetPasswordSent: 'Se ha enviado un correo electrónico para restablecer su contraseña',
    loginHelpBannerHeader: '¿Tiene problemas para iniciar sesión?',
    loginHelpBannerMessage: 'Hemos actualizado recientemente nuestro sitio web. Si es la primera vez que inicia sesión desde la actualización, {pleaseResetPassword}',
    loginHelpBannerMessageLinkText: 'restablezca su contraseña',
    loginHelpInformation: 'Información de ayuda para iniciar sesión',
    loginHelpMessage: 'Mensaje de ayuda para iniciar sesión'
  },
  card: {
    card: 'Tarjeta | Tarjetas',
    number: 'Número de tarjeta'
  },
  cart: {
    cartEmpty: 'Carrito vacío',
    clearCart: 'Vaciar carrito',
    collectedAt: 'Recogido en',
    hideCart: 'Ocultar carrito',
    removeTickets: 'Eliminar boletos',
    clickOrSwipeToRemove: 'Haz clic o desliza para eliminar {item}',
    viewCart: 'Ver carrito',
    yourCartIsEmpty: 'Su carrito está vacío',
    includeFees: 'incl. cargos'
  },
  checkout: {
    actions: {
      addGiftCardVoucherPromoCode: 'Añadir tarjeta de regalo, cupón, código promocional',
      checkout: 'Pagar',
      continueAsGuest: 'Continuar como invitado',
      continueShopping: 'Continuar comprando',
      nextStep: 'Siguiente: {step}',
      addToCart: 'Añadir al carrito',
      startOver: 'Comenzar de nuevo',
      continue: 'Continuar',
      manageMembership: 'Gestionar membresía'
    },
    addCardToTab: 'Agregar tarjeta a la cuenta',
    toCartPrice: 'al carrito ({price})',
    authRequiredForTicketsPromptConsumer: 'Inicie sesión para comprar boletos',
    authRequiredForTicketsPromptKiosk: 'Se requiere una cuenta para comprar boletos',
    confirmLeaveCheckoutPrompt: '¿Está seguro de que desea salir del proceso de pago?',
    continueOrder: '¿Quieres continuar con tu orden?',
    dontMissOutOnCollectingRewards: 'No te pierdas la posibilidad de ganar {rewardsCurrencyName}!',
    delivery: {
      delivery: 'Entrega',
      unavailable: 'Entrega no disponible',
      deliveryInformation: 'Información de entrega',
      deliveryTo: 'Entrega a',
      groupOrder: 'Orden grupal',
      groupOrderDescription: 'Selecciona los asientos de tu grupo que pueden ordenar artículos en tu cuenta',
      justMe: 'Solo yo',
      pickupAt: 'Recoger en',
      select: 'Seleccionar lugar de entrega',
      selectOptionPrompt: 'Selecciona una opción',
      selectSeats: 'Seleccionar asientos',
      yourSeat: 'Tu asiento',
      deliveryTime: 'Hora de entrega',
      selectShowing: 'Seleccionar función para entrega',
      selectShowingDescription: 'Elige la función de cine a la que deseas entregar',
      determineDeliveryMethod: 'Determinando el método de entrega...',
      times: {
        asap: 'Lo antes posible',
        early: 'Al inicio',
        middle: 'En medio',
        late: 'Al final'
      },
      deliveryName: {
        title: 'Ingrese su nombre para recoger',
        description: 'Para identificar su orden, por favor ingrese su nombre',
        yourName: 'Tu nombre',
        enterYourFullName: 'Ingrese su nombre completo',
        nameDescription: 'Este nombre se usará para identificar su orden'
      },
      cardSwipeCard: {
        swipeCard: 'Desliza la tarjeta de crédito',
        swipeCardDescription: 'Desliza la tarjeta utilizada para comprar tus boletos y encontrar tu orden'
      },
      scanOrderCard: {
        scanCard: 'Escanear confirmación de orden',
        scanCardDescription: 'Escanea el código QR o código de barras de tu confirmación de orden para encontrar rápidamente tu función',
        loadingOrder: 'Cargando orden...',
        scanNow: 'Escanear ahora'
      },
      manualSelectionCard: {
        manualCard: 'Seleccionar función manualmente',
        manualCardDescription: 'Elige entre las funciones disponibles para encontrar tu orden'
      },
      seatSelectionDialog: {
        title: 'Vincula tu orden a tu asiento',
        description: 'Para saber exactamente dónde entregar tu comida y bebida.'
      },
      seatSelectionView: {
        selectYourSeat: 'Selecciona tu asiento',
        loadingSeatChart: 'Cargando gráfico de asientos...',
        noSeatsAvailable: 'No hay asientos disponibles',
        selectRow: 'Seleccionar fila',
        selectSeat: 'Seleccionar asiento',
        loadingSeatChartDescription: 'Por favor, espera mientras cargamos los asientos disponibles para esta función.',
        noSeatsAvailableDescription: 'No hay asientos disponibles para esta función.',
        noSeatsAvailableInRow: 'No hay asientos disponibles en la fila {row}',
        noSeatsAvailableInRowDescription: 'No hay asientos disponibles en esta fila.',
        backToRowSelection: 'Volver a la selección de filas'
      }
    },
    pager: {
      requestService: 'Solicitar servicio',
      requestNow: 'Solicitar ahora',
      tabBelow: 'Toca abajo y un servidor se acercará en breve.',
      howCanWeHelp: '¿Cómo podemos ayudarte?',
      howCanWeHelpDescription: 'Selecciona el tipo de ayuda que necesitas y te notificaremos a nuestro equipo inmediatamente.',
      serviceRequested: 'Servicio solicitado',
      serviceRequestedDescription: 'Toca para cambiar o cancelar',
      helpOnTheWay: 'Hemos recibido tu solicitud de {service}. ¡Ayuda está en camino!',
      serviceRequestFailed: 'Lo sentimos, no pudimos solicitar el servicio en este momento.',
      serviceRequestCancelled: 'Solicitud de servicio cancelada',
      serviceCancelFailed: 'Lo sentimos, no pudimos cancelar la solicitud de servicio en este momento.',
      cancelRequest: 'Cancelar solicitud',
      queue: 'Cola {position}'
    },
    discountsDisclaimer: 'Los descuentos no se aplican a las tarifas ni a los impuestos',
    errors: {
      seatSelection: {
        title: 'Problema con la selección de asientos',
        message: 'Hay un problema con uno o más de los asientos que seleccionaste',
        okLabel: 'Revisar y corregir',
        cancelLabel: 'Abandonar entradas'
      },
      enterRecipientEmail: 'Por favor, ingrese una dirección de correo electrónico de destinatario',
      maxTicketLimitReached: 'Se ha alcanzado el límite de boletos',
      cardSwipe: {
        cardReaderUnavailable: 'Lector de tarjetas no disponible',
        selectToSwipe: 'Seleccionar para deslizar',
        configuringStripeTerminal: 'Configurando Stripe Terminal...',
        waitingForPayment: 'Esperando tarjeta...',
        unavailable: 'No disponible',
        unableToReadCard: 'No se puede leer la tarjeta',
        noShowingFound: 'No se encontró función',
        errorTryAgain: 'Error, intenta de nuevo'
      }
    },
    guestCheckoutHeading: 'Compra como invitado',
    infoTitles: {
      concessions: 'Concesiones',
      giftCards: 'Tarjetas de regalo',
      seatsSelected: 'Asientos seleccionados',
      tickets: 'Boletos',
      vouchers: 'Cupones'
    },
    keepTabOpen: 'Mantener la cuenta abierta',
    keepTabOpenPrompt: '¿Quieres mantener tu cuenta abierta?',
    leaveCheckoutHeading: 'Salir del pago',
    memberSignUpOrDayPassPrompt: 'Regístrese como miembro o compre un pase de día para comprar boletos',
    memberSignUpPrompt: 'Registrese como miembro para comprar boletos',
    mustSelectSeatsPrompt: 'Por favor, seleccione asientos para esta función o elimine sus boletos para continuar',
    nextLabels: {
      cart: 'Carrito',
      completeOrder: 'Completar orden',
      food: 'Comida',
      moreFilms: 'Más películas',
      pickSeats: 'Seleccionar asiento | Seleccionar asientos',
      redemptions: 'Redenciones'
    },
    orderComplete: 'Orden completa',
    orderPlaced: 'Orden realizada',
    orderPlacedAndSent: '¡Se ha realizado su order y se ha enviado el correo electrónico de confirmación!',
    orderPlacedAsOpenTab: 'Tu orden ha sido realizada como una cuenta abierta',
    orderPlacedLogInPrompt: 'Inicie sesión ahora para gestionar su orden',
    orderPlacedSignUpPrompt: 'Regístrese ahora para gestionar su orden',
    signUpToEarnPointsPrompt: 'Regístrate para ganar {pointsAmount} {rewardsCurrencyName} en tu compra',
    orderPlacedWithGuestDetailsPrompt: '¡Su orden ha sido realizado! Complete su membresía ingresando los detalles de su invitado ahora o la próxima vez que use su membresía',
    orderPlacing: 'Realizando la orden...',
    orderProcessing: 'Por favor espera mientras procesamos tu orden',
    orPayNow: 'O pagar ahora',
    paymentOptions: 'Opciones de pago',
    QRCodeOrderingPrompt: 'Puedes seguir ordenando a través del código QR o directamente con un mesero. Recogeremos la información de pago ahora.',
    receiveBenefitsHeading: 'Reciba beneficios',
    redeemCurrencyPrompt: 'Redima sus {rewardsCurrencyName} durante el pago',
    registerPromptTitle: '¿No tienes una cuenta?',
    registerPromptDescription: 'Regístrese para ganar {rewardsCurrencyName} por cada compra que podrá canjear por recompensas',
    scanCardOrSelectOptionPrompt: 'Escanee la tarjeta de membresía ahora o seleccione una de las siguientes opciones',
    signUpOrDayPassPrompt: '¿Aún no se ha registrado? Incluya un Pase de un Día con su orden',
    startNewTab: 'Abrir una cuenta',
    stepNumberOfTotal: 'Paso {step} de {total}',
    steps: {
      cart: 'Carrito',
      delivery: 'Entrega',
      foodAndDrink: 'Comida y bebida',
      options: 'Opciones',
      logIn: 'Iniciar sesión',
      membership: 'Membresía',
      moreFilms: 'Más películas',
      payment: 'Pago',
      redemptions: 'Redenciones',
      seats: 'Asientos',
      tickets: 'Boletos',
      dateAndTime: 'Fecha y hora',
      moreActivities: 'Más actividades',
      addOns: 'Adiciones',
      extra: 'Extra',
      image: 'Imagen | Imágenes',
      activity: 'Actividad'
    },
    thankYouForOrder: 'Gracias por su orden',
    ticketPackage: {
      packageExplanation: 'Algunos boletos son parte de un paquete y requieren que seleccione sus opciones de antemano. Por favor, elija las opciones requeridas a continuación para cada boleto.',
      packageTitle: 'Su boleto/película viene con opciones',
      selectYourPackageOptions: 'Seleccione sus opciones de paquete',
      selectOptionsLabel: 'Seleccionar opciones'
    },
    viewPaymentOptions: 'Haz clic para ver las opciones de pago'
  },
  collection: {
    all: 'Todo',
    current: 'Actuales',
    none: 'Ninguno',
    other: 'Otro | Otros',
    past: 'Anteriores',
    total: 'Total',
    upcoming: 'Próximos'
  },
  common: {
    at: 'en',
    favorite: 'Favorito | Favoritos',
    food: 'Comida',
    for: 'para',
    misc: 'Varios',
    nameGreeting: 'Hola, {name}',
    na: 'N/A',
    optional: 'Opcional',
    or: 'o',
    owner: 'Propietario',
    privacyPolicy: 'Política de privacidad',
    required: 'Requerido',
    socialDistance: 'Distanciamiento social',
    termsOfService: 'Términos de servicio',
    noneSelected: 'Ninguno seleccionado',
    copyright: 'Copyright',
    shapedByIndy: 'Shaped by INDY',
    allRightsReserved: 'Todos los derechos reservados.',
    min: 'Mín.',
    quantity: 'Cantidad',
    done: 'Listo',
    activityItems: 'Artículos de actividad',
    extra: 'Extra',
    image: 'Imagen | Imágenes',
    activity: 'Actividad',
    more: 'Más',
    TBC: 'TBC'
  },
  creditCard: {
    actions: {
      add: 'Añadir tarjeta de crédito',
      addDefault: 'Añadir tarjeta de crédito predeterminada',
      manage: 'Gestionar tarjeta de crédito'
    },
    addHeading: 'Añadir tarjeta de crédito',
    creditCard: 'Tarjeta de crédito | Tarjetas de crédito',
    noCardOnFile: 'No hay tarjeta registrada',
    noDefault: 'No hay tarjeta de crédito predeterminada',
    removeHeading: 'Eliminar tarjeta de crédito predeterminada',
    removePrompt: '¿Estás seguro de que quieres eliminar tu tarjeta de crédito predeterminada?',
    removeWithMembershipAutoRenewPrompt: 'Tu membresía no podrá renovarse automáticamente sin un método de pago predeterminado. ¿Estás seguro de que quieres eliminar tu método de pago predeterminado?',
    savedCreditCard: 'Tarjeta de crédito guardada',
    savedCard: 'Tarjeta guardada',
    saving: 'Guardando tarjeta de crédito...',
    updateHeading: 'Actualizar tarjeta de crédito'
  },
  currency: {
    AUD: {
      hundredthsSymbol: '¢',
      name: 'Dólar',
      symbol: '$'
    },
    AWG: {
      hundredthsSymbol: '¢',
      name: 'Florín',
      symbol: 'ƒ'
    },
    CAD: {
      hundredthsSymbol: '¢',
      name: 'Dólar',
      symbol: '$'
    },
    EUR: {
      hundredthsSymbol: '¢',
      name: 'Euro',
      symbol: '€'
    },
    GBP: {
      hundredthsSymbol: 'p',
      name: 'Libra',
      symbol: '£'
    },
    GTQ: {
      hundredthsSymbol: '¢',
      name: 'Quetzal',
      symbol: 'Q'
    },
    GYD: {
      hundredthsSymbol: '¢',
      name: 'Dólar',
      symbol: 'G$'
    },
    NZD: {
      hundredthsSymbol: '¢',
      name: 'Dólar',
      symbol: '$'
    },
    PAB: {
      hundredthsSymbol: '¢',
      name: 'Dólar',
      symbol: 'B/.'
    },
    TTD: {
      hundredthsSymbol: '¢',
      name: 'Dólar',
      symbol: 'TT$'
    },
    USD: {
      hundredthsSymbol: '¢',
      name: 'Dólar',
      symbol: '$'
    },
    XCD: {
      hundredthsSymbol: '¢',
      name: 'Dólar',
      symbol: 'EC$'
    },
    XCG: {
      hundredthsSymbol: '¢',
      name: 'Guilder',
      symbol: 'Cg'
    }
  },
  errors: {
    invalidToken: 'Token no válido'
  },
  form: {
    actions: {
      submit: 'Enviar'
    },
    enterAddressForAutocompletePrompt: 'Ingrese su dirección o código postal',
    errors: {
      cannotBeLessThanAmount: 'No puede ser menos de {amount}',
      cannotBeMoreThanAmount: 'No puede ser más de {amount}',
      emailNotFound: 'Correo electrónico no encontrado',
      emailNotValid: 'Correo electrónico no es válido',
      passwordsDoNotMatch: 'Las contraseñas no coinciden',
      passwordTooShort: 'La contraseña es demasiado corta',
      phoneNotValid: 'Número de teléfono no es válido',
      required: 'El campo es obligatorio',
      termsOfServiceRequired: 'Por favor, acepte los Términos del Servicio para continuar',
      validEmailRequired: 'Se requiere una dirección de correo electrónico válida'
    },
    labels: {
      address: 'Dirección',
      addressLine2: 'Línea de dirección 2',
      city: 'Ciudad',
      dateOfBirth: 'Fecha de nacimiento',
      emailAddress: 'Correo electrónico',
      firstName: 'Nombre',
      fullAddress: 'Dirección completa',
      addressSearch: 'Búsqueda de dirección',
      lastName: 'Apellido',
      password: 'Contraseña',
      phoneNumber: 'Número de teléfono',
      repeatPassword: 'Repetir contraseña',
      state: 'Estado',
      zipCode: 'Código postal'
    },
    masks: {
      phoneNumber: '###-###-####'
    },
    hint: {
      maxSelections: 'Máximo {count} selecciones',
      mobileDisplayLimit: 'Solo los primeros {count} se mostrarán en móvil'
    }
  },
  giftCard: {
    actions: {
      add: 'Agregar tarjeta de regalo',
      apply: 'Aplicar tarjeta de regalo',
      enterCode: 'Ingrese el código de la tarjeta de regalo',
      enterPin: 'Ingrese el PIN de la tarjeta de regalo'
    },
    addedAsPaymentMethod: 'Tarjeta de regalo añadida como método de pago',
    addedWithValue: 'Tarjeta de Regalo añadida, con un valor de {value}',
    addSuccessPrompt: '¡Tarjeta de regalo {code} agregada! Tiene un balance de {amount}',
    addToAccount: 'Agregar a la cuenta',
    balance: 'Balance',
    balanceAmount: 'Balance de la tarjeta de regalo: {amount}',
    errors: {
      alreadyAdded: '¡La tarjeta regalo {code} ya ha sido agregada! El balance actual es {amount}',
      empty: 'La tarjeta de regalo está vacía',
      expired: 'La tarjeta de regalo ha expirado',
      notFound: 'Tarjeta de regalo no encontrada',
      notValid: 'La tarjeta de regalo no es válida'
    },
    giftCard: 'Tarjeta de regalo | Tarjetas de regalo',
    giftCardBalance: 'Balance de la tarjeta de regalo',
    giftCardCount: '{count} Tarjeta de regalo | {count} Tarjetas de regalo',
    giftCardNumber: 'Número de tarjeta de regalo',
    noActiveGiftCards: 'Parece que aún no tienes una tarjeta de regalo en tu cuenta. Toca "Agregar tarjeta de regalo" para comenzar',
    noUsedOrExpiredGiftCards: 'No se encontraron tarjetas de regalo usadas o vencidas'
  },
  isoDateInput: {
    shortDate: {
      displayFormat: 'DD/MM/YYYY',
      maskedDisplayFormat: '**/**/YYYY',
      placeholder: 'DD/MM/YYYY'
    }
  },
  item: {
    item: 'Artículo | Artículos',
    itemCount: '{count} Artículo | {count} Artículos'
  },
  image: {
    missingAltText: 'Imagen personalizada para',
    headerMenuIcon: 'Icono de menú del encabezado',
    iconFor: 'Icono para { social }'
  },
  kiosk: {
    actions: {
      acknowledge: 'Entiendo',
      tapToStart: 'Toca para comenzar',
      sendCode: 'Enviar código',
      loginWithEmail: 'Iniciar sesión con correo electrónico y contraseña en su lugar',
      resendCode: 'Reenviar código'
    },
    errors: {
      hardwareProblems: 'Se encontraron problemas con el hardware, algunas funciones pueden no funcionar',
      issueWithPrinter: 'Hay un problema con la impresora. Por favor, agregue sus datos y consulte al personal del mostrador.',
      noInternet: 'Sin conexión a Internet',
      underMaintenance: 'Este terminal está en mantenimiento, disculpe las molestias',
      problemSendingEmail: 'Hubo un problema al enviar el correo electrónico. Por favor, consulte al personal del mostrador.'
    },
    inactivityPrompt: '¿Todavía estás ahí?',
    kiosk: 'Quiosco | Quioscos',
    scanCardPrompt: 'Escanea la tarjeta de membresía ahora',
    scanOrderPrompt: 'Escanea la confirmación de la orden',
    scanQRCodePrompt: 'Por favor, escanea el código QR en tu correo de confirmación',
    selectActionToStart: 'Seleccione una acción para comenzar',
    selfServiceKiosk: 'Quiosco de autoservicio',
    ticketPrintingDisabledWarning: 'Tenga en cuenta: los boletos comprados en este quiosco no se imprimirán. Se le enviarán por correo electrónico. Se requiere un teléfono inteligente para acceder a sus boletos. ¡Gracias!',
    cannotPrintTicketForPastShowtime: 'Esta función ya ha pasado. La impresión de boletos ya no está disponible. Por favor, hable con un miembro del personal si necesita ayuda.',
    useCardPrompt: 'Usa tu tarjeta virtual en la aplicación o tu tarjeta física',
    getTickets: 'Obtener boletos',
    orderFood: 'Ordenar comida',
    payHere: 'Pagar aquí',
    welcomeBack: 'Bienvenido de nuevo',
    welcomePrompt: 'Para continuar, inicia sesión con tu {phoneOrEmail}. Te enviaremos un código rápido - escríbelo aquí y ya estás dentro!',
    phone: 'teléfono',
    email: 'correo electrónico',
    phoneOrEmail: 'teléfono o correo electrónico',
    enterYourCode: 'Escribe tu código',
    enterYourCodePrompt: 'Te enviamos un código de seguridad de un solo uso a tu {phoneOrEmail}. Escribe el código aquí para iniciar sesión.',
    smsDisclaimer: 'Al ingresar su número de teléfono y continuar, acepta recibir un código de seguridad de un solo uso vía SMS para iniciar sesión en nuestro quiosco. Pueden aplicarse tarifas de mensajes y datos. Responda STOP para cancelar o HELP para obtener ayuda. <a href="{privacyPolicyUrl}" target="_blank" class="text-primary">Política de Privacidad</a>',
    resendCodePrompt: '¿No recibiste un código?',
    checkSpamPrompt: 'Revisa tu carpeta de spam/junk.',
    accountRequiredToPurchaseTickets: 'Se requiere una cuenta para comprar boletos. Escanea la tarjeta de membresía ahora o selecciona las siguientes opciones'
  },
  languages: {
    actions: {
      select: 'Seleccionar idioma'
    },
    en: 'Inglés',
    es: 'Español',
    notSelected: 'No seleccionado'
  },
  membership: {
    actions: {
      activateMembership: 'Activar membresía',
      addMember: 'Añadir miembro | Añadir miembros',
      basicMember: 'Miembro básico',
      becomeMember: 'Hazte miembro',
      cancelMembership: 'Cancelar membresía',
      changePlan: 'Cambiar plan',
      findExistingMember: 'Buscar miembro existente',
      findMember: 'Buscar miembro',
      fixPending: 'Resolver pendiente',
      fixPendingCharge: 'Resolver cargo de membresía pendiente',
      leaveAndStartSeparatePlan: 'Salir de esta membresía y comenzar un plan separado',
      lookupMember: 'Buscar Miembro',
      makeNameOwner: 'Hacer que {name} sea propietario',
      manage: 'Gestionar membresía',
      manageMember: 'Gestionar miembro | Gestionar miembros',
      memberLogIn: 'Iniciar sesión de miembro',
      modifyMember: 'Modificar miembro',
      modifyMembership: 'Modificar membresía',
      removeMember: 'Eliminar miembro',
      removeNameAndStartSeparatePlane: 'Eliminar a {name} y comenzar un plan separado',
      renewTerm: 'Renovar {term}',
      seeYourPointsActivity: 'Ver Tu Actividad de Puntos',
      selectOwner: 'Seleccionar propietario',
      turnOnRenewal: 'Activar renovación'
    },
    addFriendPrompt: 'Agrega un amigo para empezar',
    alreadyAMemberPrompt: 'Ya soy miembro',
    availableToUsePrompt: 'Disponible para usar',
    becomeMemberTodayPrompt: '¡Hágase miembro hoy y vea películas ilimitadas GRATIS!',
    cancelAutomaticMembershipRenewalPrompt: '¿Estás seguro de que quieres cancelar la renovación automática de la membresía?',
    changeTypeTooltip: 'Haz clic para cambiar el tipo de membresía',
    createAccountPrompt: 'Cree una cuenta para comprar membresía',
    deleteMemberTooltip: 'Haz clic o desliza para eliminar a este miembro',
    earnPoint: 'Gana {rewardsCurrencyName}',
    earn: {
      birthday: 'Gana {count} {rewardsCurrencyName} en tu cumpleaños',
      'concession-price': 'Gana {count} {rewardsCurrencyName} por cada {currencyName} gastado en concesiones',
      'ticket-purchase': 'Gana {count} {rewardsCurrencyName} por cada boleto comprado',
      'ticket-value': 'Gana {count} {rewardsCurrencyName} por cada {currencyName} del valor del boleto',
      visit: 'Gana {count} {rewardsCurrencyName} por cada visita',
      'membership-purchase': 'Gana {count} {rewardsCurrencyName} por la compra de una membresía',
      'gift-card-purchase': 'Gana {count} {rewardsCurrencyName} por cada tarjeta de regalo comprada',
      'gift-card-price': 'Gana {count} {rewardsCurrencyName} por cada {currencyName} gastado en tarjetas de regalo'
    },
    conditions: {
      birthday: 'en tu cumpleaños',
      birthweek: 'en tu semana de cumpleaños',
      dates: 'en las fechas dadas',
      'date-range': 'durante el rango de fechas dado',
      'day-of-week': 'en el día de la semana dado',
      discounts: 'incluyendo o excluyendo los descuentos dados',
      lifetime: 'en la vida',
      longevity: 'el miembro mantiene su tipo de membresía actual',
      movies: 'en las películas dadas',
      price: 'dentro del rango de precios dado (inclusive)',
      'showing-badges': 'con las insignias de la función dadas (ej. Premium, 3D)',
      'showing-birthday': 'asistiendo a funciones en tu cumpleaños',
      'showing-birthweek': 'asistiendo a funciones en tu semana de cumpleaños',
      'showing-dates': 'asistiendo a funciones en las fechas dadas',
      'showing-date-range': 'asistiendo a funciones dentro del rango de fechas dado',
      'showing-day-of-week': 'asistiendo a funciones en el día de la semana dado',
      'showing-time-of-day': 'asistiendo a funciones dentro del rango de tiempo dado en los días aplicables',
      sites: 'en las ubicaciones dadas',
      tier: 'en los niveles dados',
      'tier-upgrade': 'en nivel up',
      'time-of-day': 'dentro del rango de tiempo dado en los días aplicables',
      'title-classes': 'en las clases de título dadas',
      vouchers: 'incluyendo o excluyendo los cupones dados'
    },
    editMemberDetailsTooltip: 'Haz clic para editar los detalles de este miembro',
    enabledAutomaticMembershipRenewalPrompt: '¿Estás seguro de que quieres habilitar la renovación automática de la membresía?',
    enableRenewalPrompt: 'Habilitar renovación',
    errors: {
      cannotModifyOnline: 'El tipo de membresía seleccionado no se puede modificar en línea, selecciona un tipo de membresía diferente o contacta al cine',
      currentUserIsNotOwner: 'No eres el propietario de esta membresía',
      invalidMembershipVoucher: 'No se puede aplicar el cupón debido a una membresía no válida',
      nameCannotBeOwnerWithReasons: '{name} no puede ser propietario de la membresía. Necesita tener {reasons}.',
      nameMembershipTypeNotAvailableForVoucher: 'El tipo de membresía "{type}" de {name} no está disponible para el cupón aplicado',
      selectedRenewalPeriodNotAvailableForVoucher: 'El período de renovación seleccionado no está disponible para el cupón aplicado',
      selectedTypeNotAvailableForRenewalPeriod: 'El tipo de membresía seleccionado no está disponible para el período de renovación elegido',
      selectedUserIsNotOwner: 'El usuario seleccionado no es el propietario de esta membresía',
      typeNotAvailableForSelectedRenewalPeriod: 'El tipo de membresía del usuario "{type}" no está disponible para el período de renovación seleccionado',
      userHasPaidMembership: 'El usuario ya existe y tiene una membresía pagada. Debes modificar su membresía actual primero y moverlo a un plan gratuito.',
      voucherMembershipTypeNotAvailableForName: 'El tipo de membresía del cupón "{type}" no está disponible para {name}'
    },
    expiredIn: 'Vence el {date}',
    expiringPrompt: 'Por vencer',
    fixCheckoutErrorsTooltip: 'Por favor, corrige los errores pendientes de la membresía antes de finalizar la compra',
    getFreeTicketEveryTermPrompt: 'Obtén {count} boleto GRATIS cada {term} | Obtén {count} boletos GRATIS cada {term}',
    invalidRenewalPeriodTooltip: 'El período de renovación no es válido para uno o más miembros',
    joinTodayPrompt: 'Únete hoy',
    keepTrackYourMoviesPrompt: '¡Lleva un registro de todas las películas que has visto! Obtén recomendaciones personalizadas',
    linkAMemberPrompt: 'Vincular un miembro',
    memberCount: '{count} Miembro | {count} Miembros',
    memberDetails: 'Detalles del miembro',
    memberLimitCountTooltip: 'Se pueden incluir hasta {count} miembros en una sola membresía',
    membership: 'Membresía | Membresías',
    membershipAndBillingPrompt: 'Membresía y facturación',
    membershipCard: 'Tarjeta de membresía',
    memberSince: 'Miembro desde {time}',
    nameIsOnActivePlanTooltip: '{name} está en un plan activo y pagado. Primero debes eliminarlos de su plan existente antes de comenzar su propio plan.',
    nextBillingDate: 'Próxima fecha de facturación: {date}',
    nowActiveMessage: 'Su membresía ya está activa',
    periodStrategyDialogHeading: 'Prorratear o reemplazar membresía',
    periodStrategyDialogPrompt: '¿Quieres prorratear la tarifa de tu nueva membresía o reemplazar tu membresía actual?',
    removeMemberPrompt: '¿Estás seguro de que deseas eliminar permanentemente a este miembro?',
    removeOrDowngradeMemberPrompt: '¿Quieres eliminar o cambiar a este miembro a una membresía básica gratuita?',
    renewingPrompt: 'Renovando',
    saveAmountHeading: 'Ahorra {amount}',
    searchForMemberDialogHeading: 'Buscar miembro existente',
    subscriptionCanceled: 'Suscripción cancelada',
    tier: 'Nivel | Niveles',
    tiersPrompt: '¡Gana nuevas y mejores recompensas mientras usas tu membresía!',
    trackAndRateMovies: 'Rastrea y califica películas',
    turnOnAutoRenewalPrompt: 'Activar renovación automática',
    viewAndManageMembershipPrompt: 'Ver y gestionar la membresía',
    watchUnlimitedMoviesPrompt: 'Mira películas ilimitadas (los boletos no son transferibles, solo para miembros, no para sus invitados)',
    youAreOnActivePlanTooltip: 'Estás en un plan activo y pagado. Contacta al cine o al propietario de la membresía para que te eliminen del plan existente antes de comenzar tu propio plan.',
    youNeedMorePoints: 'Necesitas {count} mas {currencyName}',
    yourMembershipWillExpireOn: 'Tu membresía vencerá el {date}',
    ticketAndTreat: 'Boleto y Trato | Boletos y Tratos',
    visitTimes: 'visita {count} vez | visitas {count} veces',
    buyTickets: 'compra {count} boleto | compra {count} boletos',
    seeMovies: 've {count} película | ve {count} películas',
    earnPoints: 'gana {count} punto | gana {count} puntos',
    havePointsBalance: 'tiene {count} saldo de puntos',
    forEachMonth: 'para cada mes de tu membresía para obtener {name} beneficios!',
    eachYear: 'cada año para obtener {name} beneficios!',
    numberVisitEachTerm: '{count} Visita Cada {term} | {count} Visitas Cada {term}',
    numberTicketEachTerm: '{count} Boleto Cada {term} | {count} Boletos Cada {term}',
    numberMovieEachTerm: '{count} Película Cada {term} | {count} Películas Cada {term}',
    numberPointEachTerm: '{count} Punto Cada {term} | {count} Puntos Cada {term}',
    numberPointsBalanceEachTerm: '{count} Saldo de Puntos Cada {term}'
  },
  movie: {
    actions: {
      rate: 'Calificar',
      rated: 'Calificado',
      removeRating: 'Eliminar calificación de {rating} estrellas',
      select: 'Seleccionar película',
      watchTrailer: 'Ver tráiler'
    },
    cast: 'Reparto',
    comingSoon: 'Próximamente',
    director: 'Director',
    editYourWatchlistAndFavoriteMovies: 'Editar tu lista de seguimiento y tus películas favoritas',
    movie: 'Película | Películas',
    movieRatedValue: 'Clasificación {value}',
    movieRating: 'Clasificación',
    myMovies: 'Mis películas',
    nowPlaying: 'Exhibiéndose ahora',
    onSale: 'En venta',
    overview: 'Resumen',
    poster: 'Póster | Pósters',
    producer: 'Productor',
    releaseDate: 'Fecha de estreno',
    showtimes: 'Horarios',
    signInToSaveAMovie: 'Inicia sesión para guardar una película',
    youHaveSeenThisMovie: '¡Has visto esta película!'
  },
  nav: {
    actions: {
      exploreThing: 'Explorar {thing}',
      goBack: 'Regresar',
      goToHome: 'Ir a la página de inicio',
      readLess: 'Ver menos',
      readMore: 'Leer más',
      showAll: 'Mostrar todas',
      view: 'Ver',
      zoomIn: 'Acercar',
      zoomOut: 'Alejar'
    },
    moreInformation: 'Más información'
  },
  order: {
    actions: {
      appliedToOrder: 'Aplicado a la orden',
      startRefund: 'Iniciar Reembolso',
      startCredit: 'Iniciar Acreditar',
      swapOrCredit: 'Cambiar o Acreditar',
      swapOrRefund: 'Cambiar o Reembolsar',
      cancelAndRefund: 'Cancelar y Reembolsar',
      manageAtSite: 'Gestionar Orden en {siteName}'
    },
    cannotRefundReasons: {
      salesAreNotRefundable: 'Este boleto se compró en línea y no se puede reembolsar.',
      collected: 'Este boleto ya ha sido usado o recogido y no se puede reembolsar.',
      voided: 'Este boleto ya ha sido reembolsado o anulado.',
      bookingFeeNotRefundable: 'Este cargo de reserva no es elegible para un reembolso.',
      notRefundable: 'Este artículo no ha sido pagado, por lo que no se puede reembolsar.',
      itemTypeNotRefundable: '{itemType} no son elegibles para reembolsos. Otros artículos en su orden no son elegibles.',
      refundCutoff: 'Los reembolsos ya no están disponibles para esta función.',
      salesFinalForShowing: 'Todas las ventas para esta función son finales y no son elegibles para un reembolso.'
    },
    addMoreItems: 'Agregar más artículos',
    comment: 'Comentario | Comentarios',
    completeDetails: 'Completar Detalles',
    noCurrentOrders: 'No hay órdenes actuales',
    noOrders: 'No hay órdenes',
    noPastOrders: 'No hay órdenes anteriores',
    noUpcomingOrders: 'No hay órdenes próximas',
    order: 'Orden | Ordenes',
    orderHistory: 'Historial de órdenes',
    pastOrder: 'Orden anterior | Órdenes anteriores',
    qROrderingDisabled: 'La orden mediante código QR ya no está disponible para esta función',
    receipt: 'Recibo | Recibos',
    resendEmail: 'Reenviar correo electrónico',
    takeReceiptToCounterPrompt: 'Por favor lleve su recibo al mostrador para el pago',
    viewCurrentAndPastPurchasesPrompt: 'Ver compras actuales y pasadas',
    viewOrders: 'Ver orden | Ver órdenes',
    viewReceipt: 'Ver recibo',
    yourOrderNumber: 'Su número de orden',
    orderNumber: 'Número de orden'
  },
  orderCollection: {
    titles: {
      order: 'Orden',
      status: 'Estatus',
      deliveryType: 'Ubicación',
      trackYourOrder: 'Rastrear Tu Pedido'
    },
    labels: {
      ready: 'Listo',
      preparing: 'En preparación',
      confirmed: 'Pedido confirmado'
    },
    messages: {
      numberAdditionalOrdersPending: '{count} pedidos más pendientes'
    }
  },
  pages: {
    account: {
      accountDeleted: 'Cuenta eliminada',
      accountInformation: 'Información de la cuenta',
      accountOf: 'Cuenta de {name}',
      accountOverview: 'Resumen de la Cuenta',
      accountQueriesPrompt: 'Envíe un correo electrónico a {siteEmail} con más preguntas sobre su cuenta',
      contactUsPrompt: 'Contáctanos',
      deleteAccountPrompt: '¿Estás seguro de que quieres eliminar tu cuenta? Esta operación es permanente y no se puede deshacer. Puedes actualizar cualquier información personal o membresía con Modificar Membresía sin eliminar tu cuenta permanentemente.',
      deleteAccountTitle: 'Confirm Permanent Account Deletion',
      earnRewardsPrompt: '¡Gane {currencyName} para recompensas!',
      editYourContactInformationPrompt: 'Editar tu información de contacto',
      errors: {
        accountDeletedError: 'Ocurrió un error durante la eliminación de la cuenta'
      },
      myAccount: 'Mi cuenta',
      nextBooking: 'Próxima reserva',
      personalDetailsPrompt: 'Detalles Personales',
      preferredLanguageDescription: 'El contenido y los mensajes se mostrarán en este idioma siempre que sea posible',
      redeemPointsPrompt: 'Redima sus {currencyName} por recompensas!'
    },
    exploreMovies: {
      favoritesDescription: '¡Tus películas favoritas!',
      moviesCountPrompt: '¡Hay {count} más películas en esta lista!',
      noMoviesHere: 'No hay películas',
      ratingDescription: '¡Películas que has calificado!',
      searchOptionsPrompt: '¡Busca por título o fecha o actor!',
      searchPrompt: 'Busca para encontrar la película que buscas',
      signUpForListsPrompt: 'Regístrate para comenzar a crear listas',
      unconfirmedMoviesDisclaimer: 'Estas películas aún no están confirmadas, ¡ayúdanos a decidir agregándolas a tu lista de visualización!',
      watchedDescription: '¡Todas las películas que has visto en este cine!',
      watchListDescription: '¡Una lista de películas que te gustaría ver!'
    },
    kioskActionSelection: {
      chooseOptionHeading: 'Elige una opción para comenzar'
    },
    kioskCart: {
      cardVoucherScanPrompt: 'Si tienes alguna tarjeta de regalo o cupón, escanéala/deslízala ahora.'
    },
    kioskLogin: {
      actions: {
        lookupByEmailAndPassword: 'Buscar por correo electrónico y contraseña'
      },
      scanCardPrompt: 'Escanee su tarjeta virtual en la aplicación o escanee su tarjeta física.',
      scanSwipeCardHeading: 'Escanee/Deslice la Tarjeta de Membresía Ahora'
    },
    kioskPayment: {
      actions: {
        addName: 'Añadir nombre',
        printerWorkedFine: 'La impresora funcionó bien'
      },
      enterNamePrompt: 'Por favor, ingrese su nombre'
    },
    kioskUserLoginAction: {
      actions: {
        hardwareManagement: 'Gestión de hardware',
        yourOrders: 'Tus órdenes'
      },
      welcomeName: 'Bienvenido, {name}',
      whatWouldYouLikeToDo: '¿Qué te gustaría hacer?'
    },
    manageFriends: {
      actions: {
        addedFriendByCard: 'Amigo añadido mediante tarjeta',
        copiedInviteToClipboard: 'Invitación copiada al portapapeles',
        copyLinkToClipboard: 'Copiar Enlace al Portapapeles',
        linkAccount: 'Vincular cuenta',
        sendEmail: 'Enviar correo electrónico',
        sentFriendRequest: 'Solicitud de amistad enviada'
      },
      addFriendsAndFamilyBanner: 'Invita a tus amigos y familiares a permitir la compra en su nombre. Esto te permite aprovechar los beneficios de su membresía y sentarse juntos.',
      addFriendsAndFamilyHeading: 'Añadir amigos y familiares',
      addFriendsPrompt: 'Agregue a sus amigos ahora para que puedan compartir sus boletos de membresía, reservar juntos y nunca dividirse en diferentes asientos, ¡todo sin compartir una membresía!',
      addFriendsShortenPrompt: 'Agrega a tus amigos para reservar juntos y más',
      addFriendsToPurchaseTicketsTogether: '¡Añade a tus amigos y familiares para comprar boletos juntos!',
      cardInstructions: 'Ingrese el número de la tarjeta de membresía y el apellido de su amigo o familiar para establecer un vínculo con su cuenta.',
      emailInviteInstructions: 'Su amigo o familiar recibirá un correo electrónico con un enlace para autorizar la conexión de sus cuentas.',
      errors: {
        unableToCopyInviteToClipboard: 'No se pudo copiar la invitación al portapapeles'
      },
      linkInstructions: 'Comparta este enlace con sus amigos y familiares. Al hacer clic en el enlace, pueden autorizarlo a comprar en su nombre.',
      posAddFriendsToPurchaseTicketsTogether: '¡Añade amigos y familiares para comprar boletos juntos!',
      wouldYouLikeToPurchaseTicketsForOtherMembers: '¿Le gustaría comprar boletos para otros miembros?'
    },
    membership: {
      addToWatchListPrompt: '¡A su lista de visualización le faltan todas las mejores películas próximas!',
      buyTicketsPrompt: '¡Necesita comprar boletos para su próxima gran película!',
      countDaysLeft: '{count} días restantes',
      countMoreMovie: '{count} película más | {count} películas más',
      countMoreTicket: '{count} boleto más | {count} boletos más',
      countMoreVisit: '{count} visita más | {count} visitas más',
      countMorePoint: '{count} {rewardsCurrencyName} más | {count} {rewardsCurrencyName} más',
      countMovie: '{count} película | {count} películas',
      countPoint: '{count} {rewardsCurrencyName} | {count} {rewardsCurrencyName}',
      countVisit: '{count} visita | {count} visitas',
      logInPrompt: 'Inicie sesión para ver su membresía',
      myMembership: 'Mi membresía',
      point: '{rewardsCurrencyName} | {rewardsCurrencyName}',
      pointBalance: 'Saldo de {rewardsCurrencyName} | Saldo de {rewardsCurrencyName}',
      reward: 'Recompensa | Recompensas',
      termInReview: '{term} en revisión',
      tierDaysUntilDowngrade: 'Días hasta que su nivel baje de nivel (sin nueva actividad)',
      toAchieveNextTierStatus: 'Para alcanzar el estado {tier}',
      toMaintainTierStatus: 'Para mantener el estado {tier}',
      totalDays: 'Total de días',
      totalDaysDescription: 'Cuántos días ha pasado en {name}',
      totalMovies: 'Total de películas',
      totalTickets: 'Total de boletos',
      totalVisits: 'Total de visitas',
      visit: 'Visita | Visitas'
    },
    modifyMembership: {
      heading: 'Detalles de la membresía'
    },
    moreFilms: {
      heading: 'Otras películas que podrían interesarle'
    },
    orderConfirmation: {
      takeTicketsReminder: 'Recuerde tomar sus boletos',
      yourTicketsHaveBeenEmailed: 'Sus boletos han sido enviados por correo electrónico a {email}',
      noEmailProvided: 'No se ha facilitado correo electrónico'
    },
    payment: {
      actions: {
        managePaymentMethod: 'Gestionar método de pago',
        payAtCounter: 'Pagar en el mostrador',
        printAndPayAtCounter: 'Imprimir y pagar en el mostrador'
      },
      changeDueHeading: 'Cambio debido',
      confirmNewPriceAndRetryPrompt: 'Por favor, confirme el nuevo precio e intente completar su orden nuevamente.',
      connectingToCardReader: 'Conectando con el lector de tarjetas...',
      contactDetailsHeading: 'Detalles de contacto',
      deliveryHeading: 'Entrega',
      errors: {
        canOnlyCancelPendingOrder: 'Solo puedes cancelar una orden pendiente',
        cardPaymentsUnavailable: 'Pagos con tarjeta no disponibles',
        invalidPromoCode: 'Código promocional no válido',
        invalidPromoCodeOrCEACard: 'Código promocional o tarjeta CEA no válidos',
        ceaTicketsAreUnavailable: 'Las tarjetas CEA no están disponibles, por favor contacte con el cine.',
        issueWithOrder: 'Hubo un problema al completar su orden',
        issueWithPayment: 'Hubo un problema con su pago',
        invalidCEACard: 'Tarjeta CEA válida, la orden no contiene ningún boleto redimible CEA.',
        alreadyAppliedCEACard: 'La tarjeta CEA ya ha sido aplicada.',
        limitedRunDiscountNoLongerValid: 'El descuento de edición limitada ya no es válido',
        priceForItemsHaveChanged: 'El precio de los artículos que está comprando ha cambiado.',
        problemWithOrderTryAgain: 'Hay un problema con su orden, por favor comience de nuevo e intente nuevamente',
        unableToCommunicateWithChipReaderPayAtCounter: 'No se puede comunicar con el lector de chip, por favor pague en el mostrador',
        notFound: 'Código no encontrado',
        paymentDoesNotMatchTotal: 'El pago no coincide con el total'
      },
      foodAndDrinkHeading: 'Comida y bebida',
      insertSwipeOrTapCardPrompt: 'Inserte, deslice o toque su tarjeta ahora',
      membershipRequiresRecurringPayments: 'La membresía que está comprando requiere pagos recurrentes.',
      pleaseTakeYourReceiptToCounter: 'Por favor, lleve su recibo al mostrador',
      pleaseWaitWhileWePlaceYourOrder: 'Por favor espere mientras procesamos su orden...',
      priceChangeHeading: 'Cambio de precio',
      updateDetailsPrompt: 'Actualiza tus datos',
      completeOrderPrompt: 'Completa tu orden',
      smsNotificationPrompt: 'Ingrese su número de teléfono móvil para recibir una notificación por texto cuando su orden de comida esté lista. Puede cancelar en cualquier momento.',
      smsReceiptOption: 'Enviarme un recibo por SMS'
    },
    paymentMethods: {
      heading: 'Gestionar tarjetas de pago',
      youHaveAPendingChargeOf: 'Tiene un cargo pendiente de {amount}',
      yourAccountIsCurrent: '¡Su cuenta está al día!'
    },
    redemptions: {
      redemptionRenewsCondition: '{name} hasta {limit} redenciones {renews}',
      redemptions: 'Redenciones',
      rewardsAvailable: '{count} {currencyName} disponibles para gastar',
      rewardsIncludeHeading: 'Las recompensas de {currencyName} incluyen:',
      seeRedemptions: 'Ver sus redenciones disponibles',
      toEarnRewardsCurrencyWithEveryPurchase: 'para ganar {currencyName} con cada compra.',
      usingRewards: 'Usando {count} de {currencyName}',
      noRedemption: 'No se encontraron canjes'
    },
    refundOrder: {
      heading: 'Reembolso de Orden',
      onlineRefundsAreToUserCredit: 'Si solicita un reembolso en línea, el importe se emitirá como crédito de cuenta, mantenido en su saldo de cliente',
      onlineRefundsAreToCreditOrCard: 'Si solicita un reembolso en línea, el importe se devolverá a la tarjeta de crédito utilizada para la compra. Si no es posible un reembolso en tarjeta por alguna razón, el importe se emitirá como crédito de cuenta, mantenido en su saldo de cliente',
      repurchasingSameShowing: 'Puede volver a comprar la misma función más tarde, pero solo si todavía hay disponibilidad',
      swapShowingsInstructions: 'Para cambiar de funciones, primero reembolse, luego compre nuevos boletos',
      ticketsWillBeReleased: 'Una vez que reembolse, sus boletos serán liberados',
      notRefundToYourCard: 'Este no es un reembolso a su tarjeta',
      youCanUseTheCreditNextTime: 'Puede usar el crédito la próxima vez que realice el pago como método de pago',
      accountCreditNote: 'Nota: El crédito de cuenta no es un reembolso financiero. Solo puede ser utilizado para futuras reservas y aparecerá como una opción de pago en el pago'
    },
    creditOrder: {
      heading: 'Orden de Crédito'
    },
    selectTickets: {
      selectYourTicket: 'Seleccione su boleto',
      additionalTickets: 'Boletos adicionales',
      greeting: ctx => {
        const name = ctx.named('name')
        const membershipTypesAvailable = ctx.named('membershipTypesAvailable') || false
        return (name ? `Hola ${name},` : 'Hola,') + ' elija sus boletos' + (membershipTypesAvailable ? ' de miembro' : '')
      },
      maximumTicketsPerOrderMessage: 'Máximo de {limit} boletos por orden',
      noTicketsMessage: 'No hay boletos disponibles'
    }
  },
  payment: {
    actions: {
      addWithChipReader: 'Añadir con lector de chip',
      cashAmountDoesNotMatchSplit: 'El monto en efectivo no coincide con la división',
      payAmountWithMethod: 'Pagar {amount} con {method}',
      payLaterCannotBeUsedWithSwaps: 'PAY LATER no se puede usar con swaps',
      refundOriginalTickets: 'Reembolsar los boletos originales',
      startNewOrderForNewTickets: 'Comenzar una nueva orden para los nuevos boletos',
      payWithMethod: 'Pagar con {method}',
      printReceipt: 'Imprimir recibo',
      processCashPayments: 'Procesar pagos en efectivo',
      reconnectToChipReader: 'Volver a conectar con el lector de chip',
      redeem: 'Redimir',
      redeemed: 'Redimido',
      useGiftCardOfValue: 'Usar tarjeta de regalo de {value}',
      useGiftCardBalance: 'Usar saldo de tarjeta de regalo',
      useUserGiftCardsBalance: 'Usar saldo de tarjetas de regalo de usuario',
      redeemGiftCard: 'Redimir tarjeta de regalo {uid}',
      useValueOfCredit: 'Usar {value} de crédito',
      useUserCredit: 'Usar crédito de usuario',
      placeOrder: 'Colocar orden'
    },
    check: 'Cheque | Cheques',
    configuringReader: 'Configurando lector...',
    errors: {
      chipReaderNotConnected: 'Lector de chip no conectado',
      noChipReaderSelected: 'No se ha seleccionado un lector de chip'
    },
    method: 'Método de pago | Métodos de pago',
    payment: 'Pago | Pagos',
    paymentInfoPrompt: 'Administre sus tarjetas de crédito y regalo guardadas',
    paymentInformation: 'Información de pago',
    processing: 'Procesando pago...',
    required: 'Pago requerido',
    waitingForCustomerToProvidePayment: 'Esperando a que el cliente proporcione el pago',
    ending: 'terminando'
  },
  permission: {
    actions: {
      whyCantIAccessThis: '¿Por qué no puedo acceder a esto?'
    },
    errors: {
      accessDenied: 'Acceso denegado',
      permissionDeniedForRole: 'El permiso {permissionName} no fue concedido al rol {roleName} porque:',
      permissionDeniedWithoutRole: 'El permiso {permissionName} no fue concedido porque:'
    },
    details: 'Detalles:'
  },
  person: {
    dayPassHolder: 'Titular de pase de día',
    existingCustomer: 'Cliente existente',
    existingCustomerWithoutEmail: 'Cliente existente sin correo electrónico',
    friend: 'Amigo | Amigos',
    newCustomer: 'Nuevo cliente',
    you: 'usted'
  },
  discount: {
    applied: 'Descuento aplicado: {discount}'
  },
  donation: {
    honoreeName: 'Nombre del Homenajeado',
    donate: 'Donar'
  },
  pricing: {
    additionalFeePerTicketApplied: 'Se aplica {amount} de {feeName} adicional al finalizar la compra',
    additionalFeePerTicketAppliedPerTicket: 'Se aplica {amount} de {feeName} adicional por boleto al finalizar la compra',
    balanceIsOfValue: 'Balance de {value}',
    change: 'Cambio',
    credit: 'Crédito',
    creditUnit: 'Crédito | Créditos',
    discount: 'Descuento | Descuentos',
    donation: 'Donación | Donaciones',
    free: 'Gratis',
    pricing: 'Precios',
    remaining: 'Restante',
    savings: 'Ahorros',
    subtotal: 'Subtotal',
    surcharge: 'Recargo',
    tax: 'Impuestos',
    taxable: 'Gravable',
    ticketPriceIncludesAmountOfFee: 'El precio del boleto incluye {amount} {feeName}',
    tip: 'Propina | Propinas',
    total: 'Total',
    totals: 'Totales',
    custom: 'Personalizado',
    startingAt: 'Desde'
  },
  screen: {
    screen: 'Pantalla | Pantallas'
  },
  search: {
    actions: {
      clearFilters: 'Limpiar filtro | Limpiar filtros',
      filter: 'Filtrar',
      filterBy: 'Filtrar por',
      search: 'Buscar'
    },
    alphabetical: 'Alfabético',
    for: {
      anything: 'Buscar cualquier cosa...',
      member: 'Buscar miembro',
      movieOrPage: 'Buscar una película o página...',
      titleGenreActorDate: 'Título, género, actor, fecha...',
      venue: 'Buscar un lugar',
      location: 'Buscar un lugar'
    },
    noMatches: 'Sin coincidencias',
    noResults: 'Sin resultados'
  },
  seatChart: {
    actions: {
      selectSeat: 'Seleccionar asiento | Seleccionar asientos',
      setHeldSeatCount: 'Establecer cantidad de asientos reservados',
      keepThem: 'Mantenerlos',
      removeThem: 'Eliminarlos'
    },
    errors: {
      mustNotExceedSeatCountTicketsSoldCount: 'No debe exceder el número de asientos - boletos vendidos ({count})'
    },
    legend: 'Leyenda de asientos',
    customSeatType: 'Personalizado {seatType}',
    newHeldSeatCount: 'Nueva cantidad de asientos reservados',
    noSeatsSelected: 'No hay asientos seleccionados',
    priorSeats: 'Asientos previos',
    socialDistancing: 'Distanciamiento social',
    types: {
      couch: 'Sofá',
      recliner: 'Reclinable',
      regular: 'Regular',
      table: 'Mesa',
      wheelchair: 'Silla de ruedas',
      companion: 'Acompañante'
    },
    pinchZoom: 'Pellizcar para hacer zoom',
    scrollZoom: 'Desplácese para ampliar',
    selectSeatToContinue: 'Seleccione un asiento para continuar',
    selectSeatsToContinue: 'Seleccione {count} asientos para continuar',
    selectTicketToContinue: 'Seleccione un boleto para continuar',
    selectTicketsToContinue: 'Seleccione {count} boletos para continuar',
    capacityPercentFull: '{count}% lleno',
    newShowtimeSelected: 'Nueva función seleccionada',
    newShowtimeSelectedPrompt: 'Tiene boletos en su carrito para otra función',
    currentShowtime: 'Función actual',
    newShowtime: 'Nueva función',
    seat: 'Asiento'
  },
  showing: {
    actions: {
      viewNext: 'Ver siguiente función | Ver siguientes funciones'
    },
    noLongerAvailableForPurchaseOnline: 'No disponible para compra en línea',
    noMoreTicketsAvailableForShowing: 'No hay más boletos disponibles para la función',
    noShowingsToday: 'No hay funciones para hoy',
    nothingScheduled: 'Nada programado',
    nothingScheduledAtSelectedLocations: 'Nada programado en {locations}',
    predictedAttendanceLevel: 'Nivel de asistencia previsto',
    removeSearchFiltersPrompt: 'Elimina los filtros para ver más proyecciones',
    showing: 'Función | Funciones',
    showingsCalendar: 'Calendario de funciones',
    showMeTimesFor: 'Mostrarme horarios para {name}',
    showtimesFor: 'Horarios para {subject}',
    ticketsGoOnSale: 'Boletos se pondrán a la venta el {time}'
  },
  siteLocation: {
    actions: {
      add: 'Añadir ubicación | Añadir ubicaciones',
      change: 'Cambiar ubicación',
      // This is actually "Update location", which seems more common
      select: 'Actualizar ubicación | Actualizar ubicaciones',
      useCurrentLocation: 'Usar ubicación actual',
      saveLocations: 'Guardar ubicaciones',
      chooseCinema: 'Elegir cine'
    },
    all: 'Todas las ubicaciones',
    chooseCinemaPrompt: 'Por favor, elija un cine',
    closestLocation: 'Ubicación más cercana | Ubicaciones más cercanas',
    directions: 'Direcciones',
    location: 'Ubicación | Ubicaciones',
    allLocations: 'Todas las ubicaciones',
    allLocationsShown: 'Todas las ubicaciones mostradas',
    countMore: '{count} más',
    selectLocationHeading: 'Seleccione una ubicación',
    selectLocationPrompt: 'Por favor seleccione una ubicación',
    selectLocationQuestion: '¿Actualizar ubicación?',
    watchingMovieAtADifferentLocationQuestion: '¿Vas a ver en otra ubicación?',
    whichCinemaQuestion: '¿Dónde le gustaría ver la película?',
    locateMe: 'Localizarme',
    noLocationsSelected: 'No se han seleccionado ubicaciones',
    noCinemaSelected: 'No se ha seleccionado un cine',
    locationUnavailable: 'Ubicación no disponible',
    failedToGetClosestLocations: 'Error al obtener ubicaciones más cercanas',
    failedToGetCurrentLocation: 'Error al obtener ubicación actual'
  },
  status: {
    active: 'Activo',
    available: 'Disponible',
    expired: 'Expirado',
    held: 'Reservado',
    loading: 'Cargando',
    sold: 'Vendido',
    soldOut: 'Todo vendido',
    soldOutShort: 'Todo vendido',
    status: 'Estado',
    unavailable: 'No disponible',
    used: 'Usado',
    reserved: 'Reservado'
  },
  checkoutCode: {
    errors: {
      limitReached: 'Límite de código alcanzado',
      unavailable: 'Código no disponible',
      internalError: 'Error interno del código',
      ceaCardApplied: 'La tarjeta CEA ya ha sido aplicada',
      thingCodeNotFound: 'Código de {thing} no encontrado',
      thingCodeNotValid: 'Código de {thing} no es válido',
      thingCodeExpired: 'Código de {thing} ha expirado',
      thingCodeRedeemed: 'Código de {thing} ya ha sido redimido'
    }
  },
  ticket: {
    actions: {
      addDayPass: 'Añadir pase de día',
      book: 'Reservar boleto | Reservar boletos',
      buy: 'Comprar boleto | Comprar boletos',
      buyDayPass: 'Comprar pase de día',
      print: 'Imprimir Boleto | Imprimir Boletos'
    },
    activityTicket: 'Boleto de actividad | Boletos de actividad',
    collect: 'Recoger Boleto | Recoger Boletos',
    collected: 'Boletos Recogido | Boletos Recogidos',
    dayPass: 'Pase de día',
    dayPassPurchase: 'Compra de pase de día',
    errors: {
      dayPassNoLongerValid: 'El pase de día ya no es válido'
    },
    groupTicket: 'Boleto de grupo | Boletos de grupo',
    memberTicket: 'Boleto de miembro | Boletos de miembro',
    ticket: 'Boleto | Boletos',
    ticketCount: '{count} Boleto | {count} Boletos',
    ticketsLeftCount: '{count} Boleto restante | {count} Boletos restantes',
    ticketsRemaining: 'Boletos restantes',
    ticketsRemainingCount: '{count} Boleto restante | {count} Boletos restantes',
    ticketsSold: 'Boletos vendidos',
    viewTicketOptions: 'Ver opciones de boletos'
  },
  time: {
    actions: {
      selectDateAndTime: 'Seleccionar fecha y hora'
    },
    annually: 'Anual',
    biannually: 'Semestral',
    birthday: 'Cumpleaños',
    date: 'Fecha',
    endDate: 'Fecha de finalización',
    endsToday: 'Termina hoy',
    endsTomorrow: 'Termina mañana',
    expiresAt: 'Expira en {time}',
    leavesSoon: 'Se va pronto',
    month: 'Mes | Meses',
    monthCount: '{count} Mes | {count} Meses',
    monthly: 'Mensual',
    onDate: 'El {date}',
    otherDateWithIcon: 'Otra {icon} Fecha',
    quarterly: 'Trimestral',
    redeemedAtTime: 'Redimido a las {time}',
    startingSoon: 'Comienza pronto',
    starts: 'Comienza',
    startsOn: 'Comienza {time}',
    today: 'Hoy',
    tomorrow: 'Mañana',
    year: 'Año | Años'
  },
  user: {
    account: 'Cuenta | Cuentas',
    actions: {
      addToFavorites: 'Añadir a favoritos',
      addToWatchList: 'Añadir a lista de visualización',
      deleteAccount: 'Eliminar cuenta',
      editDetails: 'Editar detalles',
      find: 'Buscar usuario',
      manageFriends: 'Gestionar amigos',
      manageMarketingPreferences: 'Gestionar preferencias de marketing',
      removeFromFavorites: 'Eliminar de favoritos',
      removeFromWatchList: 'Eliminar de la lista de visualización',
      retryPayment: 'Reintentar pago',
      seeAllFavorites: 'Ver todos los favoritos',
      select: 'Seleccionar usuario'
    },
    allowPurchasesBy: 'Permitir compras realizadas por',
    employeeDetails: 'Detalles del empleado',
    emptyFriendsList: 'Su lista de amigos está vacía',
    manageContactMethod: 'Gestiona cómo te contactamos',
    marketingPreferences: 'Preferencias de Marketing',
    pickedForYou: 'Elegido para usted',
    point: 'Punto | Puntos',
    preferredLanguage: 'Idioma preferido',
    userClass: 'Clase de usuario',
    watchList: 'Lista de visualización',
    success: '¡Gracias por registrarse!'
  },
  voucher: {
    actions: {
      enterCode: 'Ingresar código de cupón',
      use: 'Usar cupón'
    },
    copiedToClipboard: 'Código copiado al portapapeles',
    errors: {
      copyFailed: 'Error al copiar',
      hasExpired: 'Cupón ha expirado',
      invalid: 'Cupón no válido',
      notFound: 'Cupón no encontrado',
      notValid: 'Cupón no es válido',
      alreadyRedeemed: 'Cupón ya redimido'
    },
    expiredAbbreviation: 'Venc.',
    myVoucher: 'Mi Cupón | Mis Cupones',
    noAvailableVouchersPrompt: 'No tienes cupones disponibles',
    voucher: 'Cupón | Cupones',
    voucherCount: '{count} Cupón | {count} Cupones',
    applied: 'Cupón aplicado',
    partialGiftCardApplied: 'Solo parte de la tarjeta de regalo fue aplicada. El saldo restante es demasiado pequeño para procesar con una tarjeta.'
  },
  voucherPackage: {
    actions: {
      selectAllCountNotRedeemed: 'Seleccionar todos ({count}) no redimidos'
    },
    errors: {
      invalidPackage: 'Paquete de cupón no válido',
      notValid: 'No válido'
    },
    packageNameHeading: 'Paquete de cupón: {name}',
    purchase: 'Compra de paquete de cupones',
    stateNotRedeemed: '{state}, No redimido',
    voucherPackage: 'Paquete de cupones | Paquetes de cupones',
    voucherTypeHeading: 'Tipo de cupón: {type}'
  },
  activitySelectDateAndTime: {
    titles: {
      availableTimes: 'Horarios Disponibles',
      availableLanes: 'Carriles Disponibles',
      date: 'Fecha'
    },
    labels: {
      selectTime: 'Seleccionar una Hora'
    },
    messages: {
      selectTicketsToViewAvailableTimes: 'Selecciona boletos para ver horarios disponibles',
      mustSelectMinimumAttendance: 'Debes seleccionar al menos {minimumAttendance} boletos',
      availableAtSpace: 'Disponible en {spaceName}'
    }
  }
}
